/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Keep the "(Save X%)" badge next to the price in sync when the variant changes */
document.addEventListener('variant:changed', function (event) {
  var variant = event && event.detail && event.detail.variant;
  var badge = document.querySelector('[data-saved-badge]');
  if (!variant || !badge) { return; }

  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    var percent = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
    badge.textContent = '(Save ' + percent + '%)';
    badge.hidden = false;
  } else {
    badge.hidden = true;
  }
});
